// @ts-nocheck
import $ from 'jquery';
import us from 'mesitis/services/userService';
import commonFunctions from 'mesitis/utils/commonFunctions';
import 'idleTimer';

const defaultObserverId = "normalizedSessionIdleTimer";
    const defaultIdleTimeout = 30000; // in milli seconds 
    const defaultPingInterval = 60000; // in milli seconds 

    class normalizationSessionObserver {
        /**
         * Will activate only for normalization preview page. Once activated will record user activity in DB via API calls.
         * @param {object}  -> {idleTimeout:int,uniqueId:string, useSessionSyncAcrossTab:bool } . If  idleTimeout not provided, default value = 30000. If uniqueId not provided default value = "normalizedSessionIdleTimer".
         */
        constructor(params) {
            if (params) {
                this.idleTimeout = params.idleTimeout || defaultIdleTimeout;
                this.id = params.uniqueId || defaultObserverId;
                this.useSessionSyncAcrossTab = (params.useSessionSyncAcrossTab === undefined) ? true : params.useSessionSyncAcrossTab;
                this.callOpenLogApiOnLoad = (params.callOpenLogApiOnLoad === undefined) ? false : params.callOpenLogApiOnLoad;
                this.pingInterval = params.pingInterval || defaultPingInterval;
            } else {
                this.idleTimeout = defaultIdleTimeout;
                this.id = defaultObserverId;
                this.useSessionSyncAcrossTab = true;
                this.callOpenLogApiOnLoad = false;
                this.pingInterval = defaultPingInterval;
            }
            this.unloadHandlerCalled = false; //to prevent multiple handler logic execution. for window.close() + dispatchEvent , may get called twice
            this.timerId = null;
            this.browserTabId = commonFunctions.getBrowserTabId();
        }

        startTimer() {
            const self = this;

            if (self.isNormalizationPage()) {
                const queryParams = window.location.search;
                const urlParams = new URLSearchParams(queryParams);
                const sessionId = urlParams.get('sessionIds');
                if (sessionId) {
                    us.getCurrentUser().done(function (user) {
                        const isCurrentLoggedInUserInternal = (us.IsAdmin(user.role) || us.IsEmployee(user.role));
                        if (isCurrentLoggedInUserInternal) {
                            if (self.callOpenLogApiOnLoad) {
                                self.normalizationSessionAccessStarted(sessionId);
                            }
                            self.startNormalizedSessionObserver(sessionId);
                            $(window).off('beforeunload.normalizedSession').on('beforeunload.normalizedSession', (event) => {
                                //triggered when browser/tab closed, page change/reload etc
                                if (!self.unloadHandlerCalled) {
                                    //event.preventDefault();
                                    //event.returnValue = 'beforeunload';
                                    self.normalizationSessionAccessEnded(sessionId);
                                    // when excel download using document.location.href beforeunload is triggered but Page is not reloaded and hence idleTimer is not reset/intialized
                                    $(document).idleTimer("reset", self.id);
                                    self.unloadHandlerCalled = true;
                                }
                            });

                            //$(window).off('pageshow.normalizedSession visibilitychange.normalizedSession').on('pageshow.normalizedSession visibilitychange.normalizedSession', (event) => {
                            //    if ((event.type === "visibilitychange" && document.visibilityState === 'visible') || (event.type !== "visibilitychange")) {
                            //        // required for same session multiple tabs. one of the tab closer may close the db  log. 
                            //        // Need to reset reopen log as soon as other tab is visited 
                            //        $(document).idleTimer("reset", self.id);
                            //    }
                            //});
                        }
                    });
                }
            }
        }

        startNormalizedSessionObserver(sessionId) {
            const self = this;
            const $document = $(document);
            const timerParams = { timeout: self.idleTimeout, idle: true };
            if (this.useSessionSyncAcrossTab) {
                timerParams.timerSyncId = sessionId;
            }
            $document.idleTimer(timerParams, self.id);
            console.log("normalizationSessionObserver started for sessionId: " + sessionId);
            $document.on(("idle.idleTimer" + self.id), () => {
                // function you want to fire when the user goes idle
                console.log("sessionId: " + sessionId + " is idle, tabId: " + self.browserTabId);
                self.normalizationSessionAccessEnded(sessionId);
            });

            $document.on(("active.idleTimer" + self.id), (event, elem, obj, triggerevent) => {
                // function you want to fire when the user becomes active again
                console.log("sessionId: " + sessionId + " is activated, tabId: " + self.browserTabId);
                self.normalizationSessionAccessStarted(sessionId);
                self.unloadHandlerCalled = false;

            });
        }

        startPingSchedule(sessionId) {
            const self = this;
            if (!self.timerId) {
                self.timerId = setInterval(() => {
                    self.normalizationSessionAccessPing(sessionId);
                    console.log("sessionId: " + sessionId + " is pinged, tabId: " + self.browserTabId);
                }, self.pingInterval);
            }
        }
        endPingSchedule(sessionId) {
            const self = this;
            if (self.timerId) {
                clearInterval(self.timerId);
                self.timerId = null;
                console.log("sessionId: " + sessionId + " ping stopped, tabId: " + self.browserTabId);
            }
        }

        isNormalizationPage() {
            const pathname = window.location.pathname;
            return (pathname && (pathname.toLowerCase() === '/normalization/preview' || pathname.toLowerCase() === '/normalization/validate'));
        }
        callNormalizationSessionAccessAPI(sessionId, closeSession, pingSession) {
            const self = this;
            const params = {};
            if (closeSession !== undefined && closeSession !== null) {
                params.isCloseSession = closeSession;
            }
            if (pingSession !== undefined && pingSession !== null) {
                params.isPing = pingSession;
            }
            if (sessionId) {
                params.sessionId = sessionId;
            }
            const tabId = self.browserTabId;
            if (tabId) {
                params.tabId = tabId;
            }

            return us.logNormalizationSessionAccess(params);
            //    .done((result) => {
            //    if (result.updateBrowserTabSessionId) {
            //        self.browserTabSessionId = commonFunctions.resetBrowserTabSessionId(browserTabSessionId);
            //        console.log("sessionId: " + sessionId + ", tabId: " + self.browserTabId + " switched to tabSessionId: " + self.browserTabSessionId);
            //        self.normalizationSessionAccessStarted(sessionId);
            //    }
            //});
        }
        normalizationSessionAccessStarted(sessionId) {
            const self = this;
            const currentTime = (new Date()).getTime();
            //"active.idleTimer" gets called in all tabs, hence to throttle callNormalizationSessionAccessAPI, using localStorage with key sessionId + "_lastAccessStartedCall"
            // to ensure normalizationSessionAccessStarted does not get called multiple times   for a sessionId 
            //const key = sessionId + "_lastAccessStartedCall";
            //const lastAccessStartedCall = localStorage.getItem(key);
            //if (lastAccessStartedCall === null || (currentTime - lastAccessStartedCall) > 10) {
            //    localStorage.setItem(key, currentTime);
            return self.callNormalizationSessionAccessAPI(sessionId, false).done(() => {
                self.startPingSchedule(sessionId); //start ping after log opened.
            });
        }
        normalizationSessionAccessEnded(sessionId) {
            const self = this;
            //const key = sessionId + "_lastAccessStartedCall";
            //localStorage.removeItem(key);
            return self.callNormalizationSessionAccessAPI(sessionId, true).done(() => {
                self.endPingSchedule(sessionId); //stop ping after log closed.
            });
        }
        normalizationSessionAccessPing(sessionId) {
            return this.callNormalizationSessionAccessAPI(sessionId, null, true);
        }
    }
export default normalizationSessionObserver;
